export type Tone = "neutral" | "success" | "danger" | "warn";

const TONE_CLASS: Record<Tone, string> = {
  neutral: "text-text",
  success: "text-success",
  danger: "text-danger",
  warn: "text-warn",
};

interface StatCardProps {
  label: string;
  value: string;
  sub?: string;
  tone?: Tone;
  title?: string;
}

export default function StatCard({
  label,
  value,
  sub,
  tone = "neutral",
  title,
}: StatCardProps) {
  return (
    <div
      className="bg-bg border border-border rounded-lg p-3 min-w-0"
      title={title}
    >
      <div className="text-muted text-[0.7rem] uppercase tracking-widest">
        {label}
      </div>
      <div
        className={[
          "text-lg font-semibold mt-0.5 tabular-nums transition-colors duration-300",
          TONE_CLASS[tone],
        ].join(" ")}
      >
        {value}
      </div>
      {sub && (
        <div className="text-muted text-xs mt-0.5 truncate">{sub}</div>
      )}
    </div>
  );
}
